import React from 'react';
import Content from './components/Content';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Content />
      <Footer />
    </div>
  );
}

export default App;
